import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { createProductFirstFiltersRequest } from "@faire/retailer-shared/categories/createRequests/createProductFirstFiltersRequest";
import fetchProductCatNavFilters from "@faire/web-api--source/api/v2/search/products/cat-nav/filters/post";
export var fetchFiltersResults = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(param, param1) {
        var navigationPath, filterKeys, requestReferrer, signal;
        return _ts_generator(this, function(_state) {
            navigationPath = param.navigationPath, filterKeys = param.filterKeys, requestReferrer = param.requestReferrer, signal = param1.signal;
            return [
                2,
                fetchProductCatNavFilters(createProductFirstFiltersRequest({
                    navigationPath: navigationPath,
                    filterKeys: filterKeys,
                    requestReferrer: requestReferrer
                }), {
                    signal: signal
                })
            ];
        });
    });
    return function fetchFiltersResults(_, _1) {
        return _ref.apply(this, arguments);
    };
}();
